import React, { memo } from 'react';
import { oneOf, bool, string, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { click } from './events';
import './zone-card.scss';

const GuideZoneCard = ({ channel, major, header, details }) => {

  const { title, description: headerDescription } = header;
  const { description: detailsDescription, link, imageUrl } = details;

  const renderGuideZoneCardDesktop = () => (
    <>
      {major
        ? (
          <section className="zone-card__zone1">
            <div className="zone-card__header-wrapper">
              <h2 className="zone-card__header u__bold">{title}</h2>
              <p className="zone-card__header-text">{headerDescription}</p>
            </div>
            <div className="zone-card-details">
              <div className="zone-card-details__image">
                <Image src={imageUrl} alt="" stretchy />
              </div>
              <div className="zone-card-details__description">
                <div className="zone-card-details__text category-cards-details__text--truncate">
                  {detailsDescription}
                </div>
                <div className="zone-card-details__actions">
                  <a
                    className="bttn-outline bttn-outline--primary bttn--inline zone-card-details__btn"
                    href={link}
                    onClick={() => {
                      click({
                        pageNumber: 1,
                        position: 'r1',
                        type: title
                      });
                    }}
                  >
                    <span className="bttn__content">Read Our Guide</span>
                  </a>
                </div>
              </div>
            </div>
          </section>
        )
        : (
          <section className="zone-card__zone2">
            <div className="zone-card__header-wrapper">
              <h2 className="u__truncate zone-card__header u__bold">{title}</h2>
              <p className="zone-card__header-text">{headerDescription}</p>
            </div>
            <div className="zone-card__video-wrapper">
              <a className="zone-card__vidcap-link" href={link}>
                <div
                  className="zone-card-details__image zone-card-details__image--vidcap"
                  style={{
                    backgroundImage: `url(${imageUrl})`,
                  }}
                />
              </a>
            </div>
            <a
              className="zone-card__video-link"
              href={link}
              onClick={() => {
                click({
                  pageNumber: 1,
                  position: 'r1',
                  type: title
                });
              }}
            >
              See Our Tips
            </a>
          </section>
        )}
    </>
  );

  const renderGuideZoneCardMobile = () => (
    <a className="carousel-card" href={link}>
      <div className="carousel-card__header-wrapper">
        <div className="carousel-card__header u__bold">{title}</div>
        <div className="carousel-card__header-text">{headerDescription}</div>
        <div className="carousel-card__title-border" />
        <div className="carousel-card__description">
          <div className="carousel-card__text carousel-card__text--truncate">
            {detailsDescription}
          </div>
        </div>
      </div>
      <div className="carousel-card__image-wrapper">
        <div className="carousel-card__image">
          <Image src={imageUrl} alt="" />
        </div>
      </div>
    </a>
  );

  return channel === 'desktop'
    ? renderGuideZoneCardDesktop()
    : renderGuideZoneCardMobile();
};

GuideZoneCard.displayName = 'CategoryCards-GuideZoneCard';

GuideZoneCard.propTypes = {
  channel: oneOf(['desktop', 'mobile']),
  header: shape({
    title: string,
    description: string
  }).isRequired,
  details: shape({
    imageUrl: string,
    description: string,
    link: string
  }).isRequired,
  major: bool
};

GuideZoneCard.defaultProps = {
  channel: 'desktop',
  major: false
};

const MemoGuideZoneCard = memo(GuideZoneCard);

export { MemoGuideZoneCard as GuideZoneCard };
